import { GetterTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { FACTURA } from "./types";

type AuthGetterTree = GetterTree<FACTURA, RootState>;

export const getters: AuthGetterTree = {
  
};
